import ArrivalsDeparturesBoard from './ArrivalsDeparturesBoard';

export default ArrivalsDeparturesBoard;
